import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { PlatformTourSource } from "constants/productTour";

export interface PlatformTourState {
  isPlayerOpen: boolean;
  // Where the player was opened from, e.g. Get help doesn't show the completion toast
  source: PlatformTourSource | null;
}

const initialState: PlatformTourState = {
  isPlayerOpen: false,
  source: null,
};

export const platformTourSlice = createSlice({
  name: "platformTour",
  initialState,
  reducers: {
    openPlatformTourPlayer: (
      state,
      action: PayloadAction<PlatformTourSource>
    ) => {
      state.isPlayerOpen = true;
      state.source = action.payload;
    },
    closePlatformTourPlayer: (state) => {
      state.isPlayerOpen = false;
      state.source = null;
    },
  },
});

export const { openPlatformTourPlayer, closePlatformTourPlayer } =
  platformTourSlice.actions;

export default platformTourSlice.reducer;
